import React from "react";
import { CircularProgress, Box, Typography } from "@mui/material";

const CircularProgressBar = ({ progress }) => {
  return (
    <Box
      sx={{
        position: "relative",
        display: "inline-flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {/* Circular Progress */}
      <CircularProgress
        variant="determinate"
        value={progress}
        size={100}
        thickness={5}
        sx={{
          color: "#FFFA01",
          position: "absolute",
          zIndex: 1,
        }}
      />
      <CircularProgress
        variant="determinate"
        value={progress}
        size={100}
        thickness={5}
        sx={{
          color: "#FFFA01",
          position: "absolute",
        }}
      />
      {/* Text in the center */}
      <Typography
        component="div"
        variant="h6"
        sx={{
          color: "white", // Set font color to white
          fontFamily: "'Inter', sans-serif", // Set font to Inter
          position: "absolute",
          fontWeight: "bold",
        }}
      >
        {`${Math.round(progress)}%`}
      </Typography>
    </Box>
  );
};

export default CircularProgressBar;
